import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
export const FilespaceLoginSchema = z.object({
    filespaceId: z.string(),
});
export class FilespaceLoginDto extends createZodDto(FilespaceLoginSchema) {
}
